import { DARK_SURFACE } from 'utilities/constants/colors';

export const SUPPLY_NODE_WIDTH = 327;
// Card content measures 97px (flows) / 137px (impact assessment) at the two-line metadata worst case;
// each height is that plus SUPPLY_CARD_PADDING_Y twice and SUPPLY_CARD_BORDER_WIDTH top and bottom.
export const SUPPLY_NODE_HEIGHT = 123;
export const SUPPLY_NODE_HEIGHT_IA = 163;
export const SUPPLY_H_GAP = 300;
export const SUPPLY_V_SPACING = 30;
export const SUPPLY_GRAPH_HEIGHT = 700;

// Card title x-origin: the process-type badge plus the gap after it. Every row below the title
// (metadata, score, CTAs) indents by SUPPLY_CARD_TEXT_INDENT so resizing the badge realigns all of them.
// Unitless like its siblings, so every call site has to append `px` itself.
export const SUPPLY_CARD_ICON_SIZE = 32;
export const SUPPLY_CARD_ICON_GAP = 12;
export const SUPPLY_CARD_TEXT_INDENT = SUPPLY_CARD_ICON_SIZE + SUPPLY_CARD_ICON_GAP;

// Card gutters and edges. Highlighted cards swap the accent stripe for the 1px border, and box-sizing
// hands that 5px difference back to the content box — left padding absorbs it so the text ink never moves.
export const SUPPLY_CARD_PADDING_X = 16;
export const SUPPLY_CARD_PADDING_Y = 12;
export const SUPPLY_CARD_BORDER_WIDTH = 1;
export const SUPPLY_CARD_ACCENT_WIDTH = 6;
export const SUPPLY_CARD_PADDING_LEFT_HIGHLIGHTED = SUPPLY_CARD_PADDING_X + SUPPLY_CARD_ACCENT_WIDTH - SUPPLY_CARD_BORDER_WIDTH;

// Opacity of everything outside the hovered chain.
export const DIM_OPACITY = 0.45;

export const COLORS = {
  // Green — input edges, overflow edges, hover edges, legend
  greenLight: '#48BB78',
  greenDark: '#68D391',
  // Deeper green — expand badge, link text
  expandGreenLight: '#2EA266',
  expandGreenDark: '#268654',
  linkGreenDark: '#4ADE80',
  expandBgLight: '#F6FDF9',
  expandBgDark: '#D0F3E1',
  // Flow-direction badge outer disc, dark mode (Gray/700). Uniform across variants; the light value
  // reuses expandBgLight. Defined in its own right, not aliased to FUNCTIONAL_ACCENT_LIGHT despite the
  // shared hex, so a future change to one role can't silently move the other.
  badgeOuterDark: '#393636',
  collapseBgLight: '#FED7D7',
  collapseBgDark: '#FEB2B2',
  collapseRed: '#E53E3E',
  // Purple — consumer edges, legend, border
  purpleLight: '#9F7AEA',
  purpleDark: '#B794F4',
  datasetBlueLight: '#4299E1',
  rootOutline: '#3F59DC',
  inputBorder: '#5CD496',
  // Neutral grays — used in both orderings depending on context
  grayDim: '#AEACAC',
  grayDark: '#575454',
  borderLight: '#E7E7E7',
  // Design token Button/Grey outlined/Border — outlined CTA borders and canvas overlay outlines in dark mode
  buttonOutlinedBorderDark: 'rgba(255, 255, 255, 0.08)',
  textLight: '#231F1F',
  textDark: '#E2E8F0',
  // Dark mode surface — CTA buttons, method selector, cards, and both graph legends
  darkSurface: DARK_SURFACE,
  // Secondary CTA background, light mode only
  secondaryCtaBgLight: 'rgba(255, 255, 255, 0.04)',
  // Input edge label hover
  hoverLabelBgLight: '#C6F6D5',
  hoverLabelBgDark: '#276749',
  hoverLabelColorLight: '#276749',
  hoverLabelColorDark: '#C6F6D5',
  hoverConsumerLineLight: '#805AD5',
  hoverConsumerLineDark: '#B794F4',
  hoverConsumerLabelBgLight: '#D6BCFA',
  hoverConsumerLabelBgDark: '#44337A',
  hoverConsumerLabelColorLight: '#44337A',
  hoverConsumerLabelColorDark: '#D6BCFA',
};

// Accent for the card carrying the root's functional flow — left stripe, arrow badge and edge.
// Design tokens Gray/700 (light) and Gray/200 (dark); dark inverts so the accent clears darkSurface.
export const FUNCTIONAL_ACCENT_LIGHT = '#393636';
export const FUNCTIONAL_ACCENT_DARK = '#E7E7E7';
